module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pie"
  }, [(_vm.headline) ? _c('div', {
    staticClass: "headline"
  }, [_vm._v("\n        " + _vm._s(_vm.headline) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('vue-apex-charts', {
    attrs: {
      "options": _vm.chartOptions,
      "series": _vm.series,
      "labels": _vm.labels,
      "height": _vm.chartOptions.chart.height
    }
  }), _vm._v(" "), (_vm.total > 0) ? _c('div', {
    staticClass: "total"
  }, [_vm._v("\n        I alt " + _vm._s(_vm._f("rounded")(_vm.total)) + " timer\n    ")]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f6d19d5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/employees/learning/components/pie.vue
// module id = 836
// module chunks = 0